module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0087.jpg?v=61d8d720";